// ============================================================
// 🤖 صفحة اشتراك المساعد الذكي (للعميل)
//   - الباقات والأسعار (من الداشبورد) + طرق الدفع + زر واتساب لإرسال الإيصال
//   - "عندك كود؟" → تفعيل فوري + رسالة التفعيل والمدة
//   - حالة اشتراكه الحالية (باقي X يوم / منتهي)
// المسار: src/components/pages/BotSubscribe.jsx  — page = 'bot-subscribe'
// ============================================================
import React, { useEffect, useState } from 'react';
import { apiUrl } from '../../config/supabase';
import { NavyBg, PAGE_ROOT } from '../../config/styles';

const G1 = 'linear-gradient(135deg,#667eea 0%,#764ba2 100%)';
const CARD = { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 20, padding: 22, backdropFilter: 'blur(10px)', color: 'white' };

export default function BotSubscribe({ customer, onOpenCustModal, onSetPage, showToast }) {
  const [info, setInfo] = useState(null);
  const [me, setMe] = useState(null);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const loggedIn = customer && !customer.isGuest;

  const loadMe = () => {
    let token = ''; try { token = localStorage.getItem('cust_token') || ''; } catch {}
    if (!token) { setMe(null); return; }
    fetch(apiUrl('/api/bot/me'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }) })
      .then(r => r.json()).then(j => j && j.ok && setMe(j)).catch(() => {});
  };
  useEffect(() => { fetch(apiUrl('/api/bot/subscribe-info')).then(r => r.json()).then(j => j && j.ok && setInfo(j)).catch(() => {}); }, []);
  useEffect(() => { loadMe(); }, [customer?.id]); // eslint-disable-line

  const redeem = async () => {
    if (!loggedIn) { onOpenCustModal && onOpenCustModal('login'); return; }
    const c = code.trim().toUpperCase();
    if (!c) return;
    setBusy(true);
    let token = ''; try { token = localStorage.getItem('cust_token') || ''; } catch {}
    try {
      const r = await fetch(apiUrl('/api/bot/redeem'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, code: c }) });
      const j = await r.json().catch(() => ({}));
      if (r.ok && j.ok) { setDone(j); setCode(''); loadMe(); showToast && showToast('✅ اتفعّل اشتراك المساعد', 'success'); }
      else showToast && showToast(j.message || 'الكود مش صحيح', 'error');
    } catch { showToast && showToast('فشل الاتصال بالسيرفر', 'error'); }
    setBusy(false);
  };

  const Plan = ({ title, price, sub, hot }) => (
    <div style={{ ...CARD, flex: 1, minWidth: 220, textAlign: 'center', border: hot ? '2px solid #f97316' : CARD.border, position: 'relative' }}>
      {hot && <span style={{ position: 'absolute', top: -12, insetInlineStart: 16, background: '#f97316', color: 'white', fontSize: 11, fontWeight: 'bold', padding: '3px 10px', borderRadius: 999 }}>الأوفر 🔥</span>}
      <div style={{ fontSize: 15, opacity: 0.85, marginBottom: 6 }}>{title}</div>
      <div style={{ fontSize: 34, fontWeight: 900 }}>{price ? `${price} ج` : '—'}</div>
      <div style={{ fontSize: 12, opacity: 0.7 }}>{sub}</div>
    </div>
  );

  const pay = info?.payment || {};
  return (
    <div style={PAGE_ROOT}>
      <NavyBg />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '10px 16px 60px', direction: 'rtl', position: 'relative' }}>
      <div style={{ textAlign: 'center', color: 'white', marginBottom: 26 }}>
        <div style={{ fontSize: 44 }}>🤖</div>
        <h2 style={{ fontSize: 30, fontWeight: 900, margin: '6px 0' }}>اشتراك المساعد الذكي</h2>
        <p style={{ opacity: 0.8, fontSize: 14, maxWidth: 620, margin: '0 auto' }}>
          دعم فني 24 ساعة لأي استفسار بخصوص الـ AI: مونتاج، كانفا، موشن جرافيك، أوتوميشن، صناعة الفيديوهات، برومبتات جاهزة، وكل أدوات الذكاء الاصطناعي — على الموقع وعلى تليجرام.
        </p>
        <p style={{ opacity: 0.7, fontSize: 12, marginTop: 6 }}>💡 المشترك في أي كورس بياخد المساعد ببلاش لمدة {info?.free_access_months ?? 12} شهر — الاشتراك ده بعد المدة المجانية.</p>
      </div>

      {/* حالة العميل */}
      {loggedIn && me && (
        <div style={{ ...CARD, marginBottom: 18, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', borderColor: me.state === 'open' ? 'rgba(74,222,128,0.5)' : 'rgba(248,113,113,0.5)' }}>
          <span style={{ fontSize: 26 }}>{me.state === 'open' ? '✅' : '⏰'}</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold' }}>{me.state === 'open' ? `اشتراكك ساري — باقي ${me.days_left} يوم` : me.state === 'expired' ? 'اشتراكك في المساعد انتهى — جدّد دلوقتي' : 'مش مشترك في المساعد لسه'}</div>
            {me.access_until && <div style={{ fontSize: 12, opacity: 0.75 }}>{me.state === 'open' ? 'ينتهي في' : 'انتهى في'} {new Date(me.access_until).toLocaleDateString('ar-EG')}{me.telegram_linked ? ' · 📱 تليجرام مربوط' : ''}</div>}
          </div>
        </div>
      )}
      {done && (
        <div style={{ ...CARD, marginBottom: 18, background: 'rgba(74,222,128,0.12)', borderColor: 'rgba(74,222,128,0.5)', whiteSpace: 'pre-wrap', fontSize: 14 }}>{done.message}</div>
      )}

      {/* الباقات */}
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 18 }}>
        <Plan title="الباقة الشهرية" price={info?.monthly} sub="شهر كامل" />
        <Plan title="الباقة السنوية" price={info?.yearly} sub="12 شهر" hot />
      </div>
      {info?.note && <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, textAlign: 'center', marginBottom: 18 }}>{info.note}</p>}

      {/* خطوات الاشتراك */}
      <div style={{ ...CARD, marginBottom: 18 }}>
        <div style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 10 }}>📝 إزاي تشترك؟</div>
        <ol style={{ margin: 0, paddingInlineStart: 20, lineHeight: 2, fontSize: 14 }}>
          <li>حوّل قيمة الباقة على أي وسيلة من دول:
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 6 }}>
              {pay.vodafone && <span style={{ background: 'rgba(255,255,255,0.1)', padding: '4px 10px', borderRadius: 8, fontSize: 13 }}>📱 فودافون كاش: <b dir="ltr">{pay.vodafone}</b></span>}
              {pay.instapay && <span style={{ background: 'rgba(255,255,255,0.1)', padding: '4px 10px', borderRadius: 8, fontSize: 13 }}>💳 إنستاباي: <b dir="ltr">{pay.instapay}</b></span>}
              {(pay.instapay_numbers || []).map((n, i) => <span key={i} style={{ background: 'rgba(255,255,255,0.1)', padding: '4px 10px', borderRadius: 8, fontSize: 13 }}>💳 {n.label || 'إنستاباي'}: <b dir="ltr">{n.number || n}</b></span>)}
              {pay.bank && <span style={{ background: 'rgba(255,255,255,0.1)', padding: '4px 10px', borderRadius: 8, fontSize: 13 }}>🏦 {pay.bank}</span>}
            </div>
          </li>
          <li>ابعت صورة الإيصال على واتساب — هنبعتلك <b>كود التفعيل</b> فورًا.</li>
          <li>فعّل الكود من الخانة اللي تحت، أو ابعته للمساعد في الشات أو على تليجرام.</li>
        </ol>
        {info?.instructions && <p style={{ fontSize: 12, opacity: 0.75, marginTop: 8 }}>{info.instructions}</p>}
        {pay.whatsapp && (
          <a href={pay.whatsapp} target="_blank" rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginTop: 12, background: '#25D366', color: 'white', padding: '10px 18px', borderRadius: 999, fontWeight: 'bold', textDecoration: 'none' }}>
            💬 ابعت الإيصال على واتساب
          </a>
        )}
      </div>

      {/* تفعيل الكود */}
      <div style={{ ...CARD }}>
        <div style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 10 }}>🎟️ عندك كود تفعيل؟</div>
        {!loggedIn && <p style={{ fontSize: 13, opacity: 0.8 }}>سجّل دخول بحسابك الأول عشان نفعّل الكود عليه.</p>}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input value={code} onChange={e => setCode(e.target.value.toUpperCase())} placeholder="GA-XXXX-XXXX" dir="ltr"
            style={{ flex: 1, minWidth: 200, padding: '12px 14px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(0,0,0,0.25)', color: 'white', fontSize: 16, letterSpacing: 2, textAlign: 'center', fontFamily: 'monospace' }} />
          <button onClick={redeem} disabled={busy || (loggedIn && !code.trim())}
            style={{ padding: '12px 22px', background: G1, color: 'white', border: 'none', borderRadius: 12, fontWeight: 'bold', cursor: 'pointer', fontSize: 14 }}>
            {busy ? '...' : loggedIn ? '✅ تفعيل' : '🔑 سجّل دخول'}
          </button>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <button onClick={() => onSetPage && onSetPage('academy')} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.25)', color: 'white', padding: '8px 16px', borderRadius: 999, cursor: 'pointer', fontSize: 13 }}>🎓 شوف الكورسات (اشتراك في كورس = سنة مجانية)</button>
      </div>
      </div>
    </div>
  );
}
